export default "__VITE_ASSET__CF4jfbEq__"